import { MONEY_SCALE, parseHumanAmount, UNIT_PRICE_SCALE, ZERO_MONEY, } from '@aeris/money';
import { exchangeFor, } from '@aeris/printing';
/**
 * O comprovante de uma troca ou vale (F126, F148), a partir da resposta da
 * API. Saiu do diálogo do site na F307: o trocador do celular imprime o
 * mesmo papel.
 */
const money = (wire, scale = MONEY_SCALE) => parseHumanAmount(wire.replace('.', ','), scale) ?? ZERO_MONEY;
/** `2,5` e não `2.500000`, que é o que se lê no papel. */
const quantity = (wire) => wire.replace(/\.?0+$/, '').replace('.', ',');
export const exchangeToPrint = (input) => {
    const { exchange, company, template } = input;
    const slipLine = (line) => ({
        description: line.description,
        quantity: quantity(line.quantity),
        unit: line.unit,
        unitPrice: money(line.unitPrice, UNIT_PRICE_SCALE),
        lineTotal: money(line.lineTotal),
        restocked: line.restock ?? undefined,
    });
    return exchangeFor({
        kind: exchange.kind,
        // O cabeçalho e o modelo da loja (F149).
        company,
        template,
        branchName: exchange.branchName,
        number: exchange.number ?? 0,
        issuedAt: new Date(exchange.completedAt ?? exchange.createdAt),
        customerName: exchange.customerName,
        originalSaleNumber: exchange.originalSaleNumber,
        originalSaleKind: exchange.originalSaleKind,
        // F148: a troca de produto de fora diz quem aprovou com a senha.
        authorisedByName: exchange.authorisedByName,
        handledByName: exchange.handledByName,
        returned: exchange.lines
            .filter((line) => line.direction === 'returned')
            .map(slipLine),
        outgoing: exchange.lines
            .filter((line) => line.direction === 'outgoing')
            .map(slipLine),
        returnedTotal: money(exchange.returnedTotal),
        outgoingTotal: money(exchange.outgoingTotal),
        voucherCredit: money(exchange.voucherCreditAmount),
        receivable: money(exchange.differenceAmount.startsWith('-')
            ? '0'
            : exchange.differenceAmount),
        balanceAfter: money(exchange.customerBalance),
        note: exchange.note,
        exchangeId: exchange.id,
    });
};
//# sourceMappingURL=exchange-print.js.map